import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

export async function updateOrganizationHandle(organizationId: string, handle: string) {
  const url = `/web/studio/organizations/${organizationId}/handle`;

  const response = await api.executePutRequest<ObjectResponse<{ id: string; handle: string }>>(url, { handle });

  return response.data;
}
